import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";

/**
 * O painel lateral que é rota filha da lista (design D7), em `/boletos/:id`, `/faturas/:id`
 * e `/planos/:id`.
 *
 * A lista entrega as linhas dela pelo `Outlet`: `<Outlet context={linhas} />`. A `linha` é
 * só o estado inicial, para o painel não piscar com os dados já na tela atrás dele, e não
 * existe em link colado de uma linha que a página não trouxe: quem responde é a consulta
 * por `id`.
 *
 * `lista` recebe a consulta da URL e devolve o endereço da lista: é assim que fechar traz
 * os filtros de volta. O fechar é navegação comum, e o voltar do navegador faz o mesmo.
 */
export function useDetalheDaRota<T extends { id: string }>(lista: (busca: string) => string) {
  const { id } = useParams();
  if (id === undefined) throw new Error("useDetalheDaRota fora de uma rota com :id");

  const { search } = useLocation();
  const navegar = useNavigate();
  const linhas = useOutletContext<readonly T[] | undefined>();

  return {
    id,
    linha: linhas?.find((linha) => linha.id === id),
    busca: search,
    fechar: () => void navegar(lista(search)),
  };
}
